/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { toJS, runInAction, reaction } from 'mobx';
import {
  Loader, Label, Icon, Pagination, Checkbox, Input, Modal, Header
} from 'semantic-ui-react';
import { Droppable, Draggable, DragDropContext } from 'react-beautiful-dnd';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import FileSaver from 'file-saver';
import { withTranslation } from 'react-i18next';
import cx from 'classnames';
import { findOverviewSortValue, findOverviewSortColumn } from '../Extensions/MatchedSortValue';
import Footer from '../Footer/Footer';
import quickScan from '../../images/components/content_project_card/quickScan.png';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import moveFileIcon from '../../images/components/content_project_card/move-file-icon.svg';
import moreBtn from '../../images/components/content_project_card/newRisk.png';
import compareBtn from '../../images/icons/compare.png';
import newIcon from '../../images/components/content_project_card/new-icon.svg';
import deleteIcon from '../../images/components/content_project_card/delete-icon.svg';
import exportIcon from '../../images/components/content_project_card/export-icon.svg';
import scanFailIcon from '../../images/components/content_project_card/scan_fail_ic.png';
import scanQueue from '../../images/components/content_project_card/scanning_ic.png';
import jsBundled from '../../images/icons/parcel.png';
import ContentsHeaderWithResultAll from '../SubHeader/ContentsHeaderWithResultAll';
import UploadedFileCard from '../Card/UploadedFileCard';
import CompareModal from '../Modal/CompareModal';
import ScanInfoModal from '../Modal/ScanInfoModal';
import LeakageListModal from '../Modal/LeakageListModal';
import ExportModal from '../Modal/ExportModal';
import MoveFileModal from '../Modal/MoveFileModal';
import SecurityRiskUpdatedModal from '../Modal/SecurityRiskUpdatedModal';
import MiniPieChart from '../Extensions/MiniPieChart';
import DeleteModal from '../Modal/DeleteModal';
import SPDXDocumentGenerator from '../SBOM/SPDXDocumentGenerator';
import CycloneDXDocumentGenerator from '../SBOM/CycloneDXDocumentGenerator';
import VexGenerator from '../SBOM/VexGenerator';
import NISModal from '../NISTools/NISModal';
import CBOMGenerator from '../SBOM/CBOMGenerator';
import WarningModal from '../Modal/WarningModal';
import ScanResultModal from '../Modal/ScanResultModal';
import {
  REPORT_EXTENSION_CSV,
  REPORT_EXTENSION_EXCEL,
  REPORT_EXTENSION_JSON,
} from '../../constants/reports';
import api from '../../api';
import './OverviewUploadedList.css';
import WithRouter from '../Extensions/WithRouter';

class OverviewUploadedList extends Component {
  constructor(props) {
    super(props);
    const { state } = this.props;
    this.modalAction = null;
    this.modalBody = null;
    this.modalHeader = null;
    this.modalSubBody = null;
    this.updateInterval = null;
    this.isOpenNewScan = false;
    this.isReloadList = false;
    this.isPausedUpdate = false;
    const DEFAULT_PAGE_SIZE = 10;
    const DEFAULT_VIEW_MODE = 'card';

    this.state = {
      pageSize: state.user.page_limit || DEFAULT_PAGE_SIZE,
      currentPage: 1,
      activePage: '',
      viewPointArray: [],
      uploadedFiles: [],
      error: false,
      hasMore: true,
      isRefresh: false,
      isLoading: false,
      isOpenCompare: false,
      isCompareLoading: false,
      isSetLeft: false,
      isSetRight: false,
      isOpenCPM: false,
      isOpenMSI: false,
      isOpenMSU: false,
      isRunningUpdate: false,
      isOpenAlert: false,
      isMovingFile: false,
      modalExportIsOpen: false,
      isDownloadingReport: false,
      isOpenMLK: false,
      selectedUid: null,
      selectedName: null,
      scanInfoUid: '',
      selectedLeftData: {},
      selectedRightData: {},
      compareResult: {},
      currentData: {},
      currentUid: '',
      searchKeyword: '',
      startDate: '',
      endDate: '',
      componentMin: '',
      componentMax: '',
      filter: [],
      selectedFilter: '',
      radioValue: 'udtime_any',
      sortColumn: 'uploaded',
      isSort: false,
      isOpenMFM: false,
      sortValue: '8',
      totalPage: '',
      viewMode: state.user.view_mode || DEFAULT_VIEW_MODE,
      isSelectable: false,
      isCheckAll: false,
      checkValues: [],
      isResizeHeaeder: false,
      isOpenMCX: false,
      reportId: '',
      pdfElement: '',
      isRendering: false,
      isOpenAlertModal: false,
      toExport: '',
      isShowSbom: false,
      isOpenMCD: false,
      isOpenMNA: false,
      activeMenuIndex: '',
      queryString: '',
      uploadedFileName: '',
      totalCount: 0,
      isOpenMSR: false,
      isOpenMCB: false,
    };
  }

  componentDidMount() {
    const { location, navigateType, state } = this.props;

    const $contentsHeader = $('.contents_header');
    const $window = $(window);
    let { top } = $contentsHeader.offset();
    $window.on('scroll.contents_header', () => {
      if (!$contentsHeader.hasClass('fixed')) {
        top = $contentsHeader.offset().top;
      }
      if (top - $window.scrollTop() < 140) {
        $contentsHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
      }
    });

    $(document).on('mouseover', '.wide_card_wrap .list_view .file_name span', function handleFileNameMouseover() {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    $(document).on('mouseover', '.wide_card_wrap .list_view .project_name span', function handleProjectNameMouseover() {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    window.addEventListener('scroll', this.handleOnScroll);
    document.addEventListener('mousedown', this.handleClickOutside);
    window.addEventListener('resize', this.onUpdatePredicate);

    this.onUpdatePredicate();
    if (navigateType === 'POP') {
      const scrollData = toJS(state.pages.scrollData);
      const {
        pathname,
      } = location;

      if (scrollData[pathname] || scrollData[pathname] === 0) {
        this.updateHistoryStatus();
      } else {
        this.initHistoryStatus();
      }
    } else if (location.search === '') {
      this.getReportsList();
    }

    this.disposeUserReaction = reaction(
      () => {
        return {
          page_limit: state.user.page_limit,
          view_mode: state.user.view_mode
        };
      },
      ({ page_limit, view_mode }) => {
        if (page_limit !== null && view_mode !== null) {
          this.setState({
            pageSize: page_limit,
            viewMode: view_mode
          });
        }
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { state, location } = this.props;

    const {
      isRunningUpdate,
      filter,
      radioValue,
      isOpenCompare,
      isLoading,
      isSelectable,
      queryString,
    } = this.state;

    if (prevState.isLoading !== isLoading) {
      state.user.initPrecisionLevel();
    }

    if (this.isOpenNewScan && isRunningUpdate && !this.isPausedUpdate) { //open scan
      this.onUpdateStop();
      this.onUpdateStateChange('stop');
      this.isPausedUpdate = true;
    }

    if (!this.isOpenNewScan && !isRunningUpdate && !this.isReloadList) { // resume scan
      if (filter.length > 0 || radioValue !== 'udtime_any') {
        return;
      }
      this.isPausedUpdate = false;
      this.onUpdateStart();
      this.onUpdateStateChange('start');
    }

    if (!this.isOpenNewScan && !isRunningUpdate && this.isReloadList) { //close scan && direct update
      this.isPausedUpdate = false;
      this.onUpdate();
      state.report.initReload();
    }

    if (isOpenCompare !== prevState.isOpenCompare && isOpenCompare) {
      this.setState({
        activeMenuIndex: '',
        isShowSbom: false,
      });
    }

    if (isSelectable !== prevState.isSelectable) {
      this.onUpdatePredicate();
    }
    if (location.search !== queryString) {
      this.setState({
        queryString: location.search,
      }, () => {
        if (location.search === '') {
          this.removeProjectFilter();
        } else {
          this.setProjectFilter();
        }
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
    document.removeEventListener('mousedown', this.handleClickOutside);
    window.removeEventListener('resize', this.onUpdatePredicate);

    if (this.updateInterval) {
      this.onUpdateStop();
    }

    if (this.disposeUserReaction) {
      this.disposeUserReaction();
    }
  }

  handleActivePageChange = (e) => {
    const { totalPage, pageSize, activePage } = this.state;
    if (e.key === 'Enter') {
      if (activePage > totalPage) {
        return;
      }
      this.setState({
        currentPage: activePage,
        uploadedFiles: [],
        checkValues: [],
        isCheckAll: false,
      }, () => {
        this.getReportsList(activePage, pageSize);
      });
    }
  };

  handleInputActivePageChange = (e, { value }) => {
    const { totalPage } = this.state;
    if (totalPage < value) {
      return;
    }

    this.setState({
      activePage: value,
    });
  };

  handleMultipleDeleteCallback = () => {
    this.setState({
      isOpenAlert: false,
      isSelectable: false,
      uploadedFiles: [],
    }, () => {
      this.getReportsList();
    });
  };

  handleExport = (obj) => {
    this.setState({
      modalExportIsOpen: true,
      currentData: obj,
    });
  };

  handleSpdx = (uid, value) => {
    this.setState({
      isOpenMCX: true,
      reportId: uid,
      uploadedFileName: value,
    });
  };

  handleCycloneDx = (uid) => {
    this.setState({
      isOpenMCD: true,
      reportId: uid,
    });
  };

  handleVexBom = (uid) => {
    this.setState({
      isOpenMVX: true,
      reportId: uid,
    });
  };

  handleNIASbom = (uid) => {
    this.setState({
      isOpenMNA: true,
      reportId: uid,
    });
  };

  handleInfoItem = (uid) => {
    this.setState({
      scanInfoUid: uid,
      isOpenMSI: true,
    });
  };

  handleMSIClose = () => {
    this.setState({
      scanInfoUid: '',
      isOpenMSI: false,
    });
  };

  handleCBOM = (rowData) => {
    const { t } = this.props;
    const { hasCrypto, uid, name } = rowData;

    if (hasCrypto) {
      this.setState({
        isOpenMCB: true,
        reportId: uid,
        uploadedFileName: name,
      });
    } else {
      this.modalAction = t('modal.title.notice');
      this.modalBody = t('modal.message.no_crypto_data');
      this.modalHeader = null;

      this.setState({
        isOpenAlertModal: true,
      });
    }
  };

  handleClick = (uid) => {
    const { navigate } = this.props;
    const { isSelectable } = this.state;
    if (isSelectable) return;

    this.setPreviousData();
    navigate(`/results/overview/binary/${uid}`);
  };

  handleChangeView = (uid, string) => {
    const { navigate } = this.props;
    const { isSelectable } = this.state;

    if (isSelectable) return;

    this.setPreviousData();

    const pathMap = {
      component: `/results/component/binary/${uid}`,
      security: `/results/security/binary/${uid}`,
      license: `/results/license/binary/${uid}`,
      policy: `/results/policy/project/${uid}`,
    };

    const foundEntry = Object.entries(pathMap).find(([key,]) => { return string.includes(key); });

    if (foundEntry) {
      navigate(foundEntry[1]);
    }
  };

  handleOnScroll = () => {
    const {
      getReportsList,
      state: {
        error, isLoading, hasMore, uploadedFiles, viewPointArray, viewMode, pageSize
      },
    } = this;

    if (viewMode === 'list') {
      return;
    }

    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;
    const pageNo = Math.ceil(uploadedFiles.length / pageSize);

    if (error || isLoading || !hasMore) {
      return;
    }

    if (viewPointArray.length > 3) {
      const scrollPosition = scrollTop + clientHeight;
      if (scrollPosition > viewPointArray[2]) {
        if (this.updateInterval !== null) {
          this.onUpdateStop();
        }
      } else if (scrollPosition < viewPointArray[2]) {
        if (this.updateInterval === null) {
          this.onUpdateStart();
        }
      }
    }

    const px = Math.ceil(scrollHeight) - Math.ceil(scrollTop + clientHeight);
    const isNextPage = px > -2 && px < 1;

    if (Math.ceil(scrollTop + clientHeight) === Math.ceil(scrollHeight) || isNextPage) {
      this.setState({
        viewPointArray: [...viewPointArray, scrollHeight],
        isCheckAll: false,
      }, () => {
        getReportsList(pageNo + 1, pageSize);
      });
    }
  };

  handleChange = (value) => {
    this.setState(
      {
        searchKeyword: value,
        uploadedFiles: [],
      },
      () => {
        this.getReportsList();
      }
    );
  };

  handleChangeSorting = (value) => {
    const obj = findOverviewSortValue(value);
    this.setState(
      {
        sortColumn: value,
        isSort: obj.isSort,
        sortValue: obj.sortValue,
        uploadedFiles: [],
      },
      () => {
        this.getReportsList();
      }
    );
  };

  handlePageSizeChange = (value) => {
    this.setState(
      {
        pageSize: value,
        currentPage: 1,
        uploadedFiles: [],
      },
      () => {
        this.getReportsList();
      }
    );
  };

  handleFilterData = (value) => {
    this.setState(
      {
        uploadedFiles: [],
        componentMin: value.component_min,
        componentMax: value.component_max,
        startDate: value.uploaded_start,
        endDate: value.uploaded_end,
        filter: value.filter,
        radioValue: value.radio,
        checkValues: [],
        isCheckAll: false,
      },
      () => {
        this.getReportsList();
      }
    );
  };

  handleCardBookmarkChange = (uploadedFileId, isBookmark) => {
    const { state } = this.props;
    const { uploadedFiles } = this.state;

    const updatedIndex = uploadedFiles.findIndex((item) => { return item.uid === uploadedFileId; });

    if (updatedIndex === -1) {
      console.warn(`Uploaded file with ID ${uploadedFileId} not found.`);
      return;
    }

    const newUploadedFiles = [
      ...uploadedFiles.slice(0, updatedIndex),
      {
        ...uploadedFiles[updatedIndex],
        isBookmark,
      },
      ...uploadedFiles.slice(updatedIndex + 1),
    ];

    this.setState({
      uploadedFiles: newUploadedFiles,
    }, () => {
      state.report.setActiveBookMark();
    });
  };

  handleCompareChange = () => {
    const { selectedLeftData, selectedRightData } = this.state;

    const obj = {
      source_id: selectedLeftData.uid,
      target_id: selectedRightData.uid,
      base_limit: 25,
    };

    this.setState({
      isCompareLoading: true,
      isOpenCPM: true,
      isOpenCompare: false,
    }, () => {
      api
        .setCompareData(obj)
        .then((response) => {
          const data = response.response;
          this.setState({
            isCompareLoading: false,
            compareResult: data,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isCompareLoading: false,
          });
        });
    });
  };

  handleIssueCallback = () => {
    this.setState(
      {
        uploadedFiles: [],
        filter: [],
        startDate: '',
        endDate: '',
        radioValue: 'udtime_any',
        checkValues: [],
        isCheckAll: false,
      },
      () => {
        this.getReportsList();
      }
    );
  };

  handleCPMClose = () => {
    this.setState({
      isOpenCPM: false,
      compareResult: {},
    });
  };

  handleMLKClose = () => {
    this.setState({
      selectedUid: null,
      selectedName: null,
      isOpenMLK: false,
    });
  };

  handleLeakageList = (uploadedFileId, fileName) => {
    this.setState({
      selectedUid: uploadedFileId,
      selectedName: fileName,
      isOpenMLK: true,
    });
  };

  handlePaginationChange = (e, { activePage }) => {
    const { pageSize } = this.state;
    this.setState({
      searchKeyword: '',
      uploadedFiles: [],
      currentPage: activePage,
      checkValues: [],
      isCheckAll: false,
      activePage,
    }, () => {
      this.getReportsList(activePage, pageSize);
    });
  };

  handleListSortingChange = (e) => {
    const { isSort, sortValue } = this.state;
    if (e.currentTarget.dataset.id !== sortValue) {
      const currentColumn = findOverviewSortColumn(false, e.currentTarget.dataset.id);
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: false,
          sortColumn: currentColumn,
          uploadedFiles: [],
        },
        () => {
          this.getReportsList();
        }
      );
    } else {
      const currentColumn = findOverviewSortColumn(!isSort, e.currentTarget.dataset.id);
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: !isSort,
          sortColumn: currentColumn,
          uploadedFiles: [],
        },
        () => {
          this.getReportsList();
        }
      );
    }
  };

  handleMoreMenu = (value) => {
    const { activeMenuIndex } = this.state;
    if (activeMenuIndex === value) {
      this.setState({
        activeMenuIndex: '',
        isShowSbom: false,
      });
    } else {
      this.setState({
        activeMenuIndex: value,
        isShowSbom: false,
      });
    }
  };

  handleClickOutside = (e) => {
    const { activeMenuIndex } = this.state;
    const container = $('.list_view .more_menu');

    if (container && container.has(e.target).length === 0) {
      if (activeMenuIndex !== '') {
        this.setState({
          activeMenuIndex: '',
          isShowSbom: false,
        });
      }
    }
  };

  handleSecurityInfoItem = (uid) => {
    this.setState({
      isOpenMSU: true,
      currentUid: uid,
    });
  };

  handleMove = (obj) => {
    this.setState({
      isOpenMFM: true,
      currentData: obj,
    });
  };

  handleDeleteOnList = (obj) => {
    this.setState({
      isOpenAlert: true,
      currentData: obj,
    });
  };

  handleCheckAllChange = () => {
    const { isCheckAll, uploadedFiles } = this.state;
    const newState = [];

    if (isCheckAll) {
      this.setState({
        isCheckAll: false,
        checkValues: [],
      });
    } else {
      const num = uploadedFiles.length;
      let i = 0;
      for (i; i < num; i++) {
        if (uploadedFiles[i].hasPermission) {
          newState.push(uploadedFiles[i].uid);
        }
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        isCheckAll: true,
        checkValues: unique,
      });
    }
  };

  handleCheckChange = (e, { value }) => {
    const { checkValues, uploadedFiles } = this.state;
    let newState;
    if (checkValues.indexOf(value) > -1) {
      newState = checkValues.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValues, value];
    }

    if (newState.length !== 0 && newState.length !== uploadedFiles.length) {
      this.setState({
        checkValues: newState,
        isCheckAll: false,
      });
    } else {
      this.setState({
        checkValues: newState,
      });
    }
  };

  handleDeleteChange = () => {
    const { checkValues } = this.state;

    if (checkValues.length === 0) {
      this.setState({
        isOpenWarnModal: true,
      });
    } else {
      this.setState({
        isOpenAlert: true,
      });
    }
  };

  handleSlideToggle = () => {
    const { isShowSbom } = this.state;
    this.setState({
      isShowSbom: !isShowSbom,
    });
  };

  handleSearchChange = (value) => {
    this.setState({
      searchKeyword: value,
    });
  };

  handleAddScanResults = (uid) => {
    this.setState({
      isOpenMSR: true,
      reportId: uid,
    });
  };

  handleSaveCallback = () => {
    this.onUpdate();
  };

  onDragEnd = (result) => {
    const {
      source, //start
      destination, //end
      draggableId,
    } = result;

    if (!destination) {
      return null;
    }

    if (source.droppableId === destination.droppableId) {
      //reorder
      return null;
    }

    this.move(
      this.getList(draggableId),
      //destination,
      //source
    );
  };

  onUpdatePredicate = () => {
    const { isSelectable, viewMode } = this.state;
    //viewMode
    if (isSelectable) {
      this.setState({
        isResizeHeaeder: window.innerWidth < 1600,
      });
    } else if (viewMode === 'list') {
      this.setState({
        isResizeHeaeder: window.innerWidth < 1470,
      });
    } else {
      this.setState({
        isResizeHeaeder: window.innerWidth < 1395,
      });
    }
  };

  onUpdateStart = () => {
    this.updateInterval = null;
    if (!this.onUpdateRunning()) {
      const updateCheck = () => {
        this.onUpdateCheck();
        this.updateInterval = setTimeout(updateCheck, 6000);
      };
      updateCheck();
    }
  };

  onUpdateStop = () => {
    clearInterval(this.updateInterval);
    this.updateInterval = null;
  };

  onUpdateRunning = () => {
    return this.updateInterval !== null;
  };

  onUpdateStateChange = (value) => {
    if (value === 'stop') {
      this.setState({
        isRunningUpdate: false,
      });
    } else {
      this.setState({
        isRunningUpdate: true,
      });
    }
  };

  onUpdate = async () => {
    const { state, location } = this.props;
    const sliced = state.report.uploadingProgressArray.slice();
    const newState = sliced.filter((item) => {
      return item.status !== 100;
    });

    const {
      pathname,
    } = location;

    const {
      currentPage,
      pageSize,
    } = this.state;

    runInAction(() => {
      state.report.setUploadingProgressArray(newState);
    });
    state.pages.setScrollData(pathname, window.pageYOffset, currentPage, pageSize);

    this.setState(
      {
        uploadedFiles: [],
        currentPage: 1,
        isRefresh: true,
      },
      () => {
        this.getReportsList();
      }
    );
  };

  onUpdateCheck = async () => {
    if (this.updateInterval === null) {
      return this.onUpdateStop();
    }

    const { state } = this.props;
    const {
      uploadedFiles,
      selectedFilter,
      searchKeyword,
      startDate,
      endDate,
      componentMin,
      componentMax,
      viewMode,
      currentPage,
      sortColumn
    } = this.state;
    const URLparams = toJS(state.pages.url_params);
    const currentUploadedFiles = [...uploadedFiles];

    const pageSize = currentUploadedFiles.length;

    let scanningIds = [];

    const scanningArray = currentUploadedFiles.filter((item) => {
      return item.scanStatus === 0 || item.scanStatus === 1;
    });

    scanningIds = scanningArray.map((item) => {
      return item.uid;
    });

    if (viewMode === 'list' && currentPage !== 1) {
      return;
    }

    if (pageSize === 0) {
      return;
    }

    try {
      const response = await api.getScannedUpdateCheck({
        search: searchKeyword,
        uploaded_start: startDate,
        uploaded_end: endDate,
        component_min: componentMin,
        component_max: componentMax,
        filter: selectedFilter,
        page: 1,
        limit: pageSize,
        order: sortColumn,
        project_ids: URLparams.project_ids || [],
        project_version_ids: URLparams.project_version_ids || [],
        uploaded_file_ids: URLparams.uploaded_file_ids || [],
      });

      const data = response.data.response;

      if (data.length === 0) {
        return;
      }

      if (currentUploadedFiles.length !== 0 && data[0].uploaded_file_id !== currentUploadedFiles[0].uid) {
        return this.onUpdate();
      }

      if (currentUploadedFiles.length === 0 && data.length !== 0) {
        return this.onUpdate();
      }

      if (response.status === 200 && scanningIds.length !== 0) {
        const nextUploadedFiles = [...currentUploadedFiles];
        let needsStateUpdate = false;

        scanningIds.forEach((uid) => {
          /*
            scanStatus 0 => Queue
            scanStatus 1 => scanning
            scanStauts 2 => scan completed
            scanStatus 3 => scan failed
          */
          const apiItemIndex = data.findIndex((item) => { return item.uploaded_file_id === uid; });
          const stateItemIndex = nextUploadedFiles.findIndex((item) => { return item.uid === uid; });

          if (apiItemIndex === -1 || stateItemIndex === -1) {
            this.onUpdate();
            needsStateUpdate = false;
            return;
          }

          const apiItem = data[apiItemIndex];
          const currentItem = nextUploadedFiles[stateItemIndex];

          let updatedItem = { ...currentItem };
          let itemChanged = false;

          // scanStatus check
          if (apiItem.scan_status !== currentItem.scanStatus) {
            itemChanged = true;
            updatedItem = {
              ...updatedItem,
              scanStatus: apiItem.scan_status,
              scanStatusDetail: apiItem.scan_status_detail,
              uploadedGrade: apiItem.uploaded_grade,
              componentCount: apiItem.component_count,
              securityCount: apiItem.security_count,
              licenseCount: apiItem.license_count,
              litigatorCount: apiItem.litigator_count,
              scannedTime: apiItem.report_scan_time,
              policyCount: apiItem.policy_count,
              uploadedGradeBroad: apiItem.uploaded_grade_broad,
              componentCountBroad: apiItem.component_count_broad,
              securityCountBroad: apiItem.security_count_broad,
              licenseCountBroad: apiItem.license_count_broad,
              litigatorCountBroad: apiItem.litigator_count_broad,
              policyCountBroad: apiItem.policy_count_broad,
              hasExploit: apiItem.has_exploit,
              hasLeakage: apiItem.has_leakage,
              hasBundled: apiItem.has_bundled,
              isLowMemoryWaiting: apiItem.is_low_memory_waiting,
              isRescanned: apiItem.is_security_rescanned,
              useScanOption: apiItem.use_scan_option,
              jiraIssue: apiItem.jira_issue,
              hasCrypto: apiItem.has_crypto,
              isBookmark: apiItem.is_bookmark,
              precisionLevel: apiItem.precision_level,
              isUsePrecision: apiItem.is_use_precision,
              hasPermission: apiItem.has_manage_permission,
              isQuickScan: apiItem.is_quick_scan,
            };

            if (apiItem.scan_status === 2) {
              state.report.setUploadedCount();
            }
          } else if (apiItem.scan_status === 1 || currentItem.scanStatus === 1) { //scanning: update scan status detail
            if (apiItem.scan_status_detail !== currentItem.scanStatusDetail) {
              itemChanged = true;
              updatedItem = {
                ...updatedItem,
                scanStatusDetail: apiItem.scan_status_detail,
              };
            }
          }

          if (itemChanged) {
            nextUploadedFiles[stateItemIndex] = updatedItem;
            needsStateUpdate = true;
          }
        });

        if (needsStateUpdate) {
          this.setState({
            uploadedFiles: nextUploadedFiles,
          });
        }
      }
    } catch (err) {
      console.error('Error during update check:', err);
      this.setState({
        isLoading: false,
      });
      this.onUpdateStop();
    }
  };

  setProjectFilter = () => {
    const { searchParams, state } = this.props;
    const [URLSearchParams] = searchParams;
    let projectIds;
    let projectVersionIds;
    let uploadedFileIds;
    const project_id = URLSearchParams.getAll('project');
    const project_version_id = URLSearchParams.getAll('project_version');
    const uploaded_file_id = URLSearchParams.getAll('uploaded_file_id');

    if (project_id && project_id.length !== 0) {
      projectIds = project_id;
    } else {
      projectIds = [];
    }

    if (project_version_id && project_version_id.length !== 0) {
      projectVersionIds = project_version_id;
    } else {
      projectVersionIds = [];
    }

    if (uploaded_file_id && uploaded_file_id.length !== 0) {
      uploadedFileIds = uploaded_file_id;
      projectIds = [];
      projectVersionIds = [];
    } else {
      uploadedFileIds = [];
    }

    const obj = {
      project_ids: projectIds,
      project_version_ids: projectVersionIds,
      uploaded_file_ids: uploadedFileIds,
    };

    state.pages.setURLparams(obj);

    this.setState({
      currentPage: 1,
      searchKeyword: '',
      isSelectable: false,
      uploadedFiles: [],
      checkValues: [],
    }, () => {
      this.getReportsList();
    });
  };

  getList = (id) => {
    const { uploadedFiles } = this.state;
    const draggableData = uploadedFiles.filter((item) => {
      return item.uid.toString() === id;
    });

    return draggableData;
  };

  getReportsList = (pageNo, limit) => {
    const {
      radioValue,
      isRefresh,
      pageSize,
      uploadedFiles,
      filter,
      searchKeyword,
      startDate,
      endDate,
      componentMin,
      componentMax,
      sortColumn,
    } = this.state;
    const { state, location } = this.props;
    const URLparams = toJS(state.pages.url_params);

    let perPage = limit || pageSize;
    const page = pageNo || 1;
    const scrollData = toJS(state.pages.scrollData);

    const {
      pathname,
    } = location;

    const filterData = filter.join(',') + (filter.length ? ',' : '') + radioValue;

    if (isRefresh) {
      perPage = scrollData[pathname].pageSize * scrollData[pathname].currentPage;
    }

    this.setState(
      {
        isLoading: true,
      },
      () => {
        api
          .getScannedReports(
            {
              search: searchKeyword,
              uploaded_start: startDate,
              uploaded_end: endDate,
              component_min: componentMin,
              component_max: componentMax,
              filter: filterData,
              page,
              limit: perPage,
              order: sortColumn,
              project_ids: URLparams.project_ids || [],
              project_version_ids: URLparams.project_version_ids || [],
              uploaded_file_ids: URLparams.uploaded_file_ids || [],
              ...location.query
            }
          )
          .then((response) => {
            if (uploadedFiles.length !== 0 && response.pagination.current === 1) {
              this.setState({
                isLoading: false,
              });
              return false;
            }

            const nextUploadedFiles = response.response.map((item) => {
              return {
                uid: item.uploaded_file_id,
                pid: item.project_id,
                pvi: item.project_version_id,
                name: item.name,
                projectName: item.project_name,
                projectVersionName: item.project_version_name,
                isQuickScan: item.is_quick_scan,
                uploadedGrade: item.uploaded_grade,
                uploadedGradeBroad: item.uploaded_grade_broad,
                componentCount: item.component_count,
                securityCount: item.security_count,
                licenseCount: item.license_count,
                litigatorCount: item.litigator_count,
                policyCount: item.policy_count,
                componentCountBroad: item.component_count_broad,
                securityCountBroad: item.security_count_broad,
                licenseCountBroad: item.license_count_broad,
                litigatorCountBroad: item.litigator_count_broad,
                policyCountBroad: item.policy_count_broad,
                owner: item.owner,
                uploadedDate: item.uploaded_at,
                scannedTime: item.report_scan_time,
                isRescanned: item.is_security_rescanned,
                hasPermission: item.has_manage_permission,
                isScanning: item.scanning,
                scanStatus: item.scan_status,
                scanStatusDetail: item.scan_status_detail,
                isUsePrecision: item.is_use_precision,
                precisionLevel: item.precision_level,
                isLowMemoryWaiting: item.is_low_memory_waiting,
                isBookmark: item.is_bookmark,
                hasExploit: item.has_exploit,
                hasLeakage: item.has_leakage,
                hasBundled: item.has_bundled,
                useScanOption: item.use_scan_option,
                jiraIssue: item.jira_issue,
                hasCrypto: item.has_crypto,
              };
            });

            if (!isRefresh && response.pagination.current > 1 && document.documentElement.scrollTop > 300) {
              window.scrollTo(0, document.documentElement.scrollTop - 150);
            }

            if (isRefresh) {
              this.setState({
                currentPage: scrollData[pathname].currentPage,
                pageSize,
                totalPage: response.pagination.pages,
                totalCount: response.pagination.count,
                hasMore: response.pagination.next !== null,
                isLoading: false,
                uploadedFiles: [...uploadedFiles, ...nextUploadedFiles],
                selectedFilter: filterData,
                isRefresh: false,
              }, () => {
                this.updateAutoScroll();
              });
            } else {
              this.setState({
                currentPage: response.pagination.current,
                pageSize: response.pagination.per_page,
                totalPage: response.pagination.pages,
                totalCount: response.pagination.count,
                hasMore: response.pagination.next !== null,
                isLoading: false,
                uploadedFiles: [...uploadedFiles, ...nextUploadedFiles],
                selectedFilter: filterData,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoading: false,
            });
          });
      }
    );
  };

  setPreviousData = () => {
    const { location, state } = this.props;
    const {
      pathname,
    } = location;
    const {
      searchKeyword,
      sortColumn,
      filter,
      radioValue,
      uploadedFiles,
      currentPage,
      viewMode,
      pageSize,
      totalCount,
    } = this.state;

    const status = {
      searchKeyword,
      sortColumn,
      filter,
      radioValue,
      uploadedFiles,
      viewMode,
      pageSize,
      totalCount,
    };
    state.pages.setStatusData(status);
    state.pages.setScrollData(pathname, window.pageYOffset, currentPage, pageSize);
  };

  setCompareItem = (obj) => {
    this.setState({
      isOpenCompare: true,
      isSetLeft: true,
      isSetRight: false,
      selectedLeftData: obj,
      selectedRightData: {},
    });
  };

  setCompareItemOnList = (obj) => {
    this.setState({
      selectedRightData: obj,
      isSetRight: true,
    });
  };

  setFileMove = (obj, id) => {
    this.setState({
      isMovingFile: true,
    }, () => {
      api.setFileMove({
        selected_project_id: obj.selectedProject.id,
        selected_project_version_id: obj.selectedProjectVersion.id,
      }, id)
        .then(() => {
          this.setState({
            isMovingFile: false,
            isOpenMFM: false,
          }, () => {
            this.updateFilePath(obj, id);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  createElementWithCanvas = () => {
    const { viewMode } = this.state;
    //pdfElement
    const contentElem = document.querySelector('.content');
    if (contentElem) {
      const wrapper = contentElem.closest('.container');
      const clonedObject = wrapper.cloneNode(true);
      const containerEl = clonedObject.closest('.container');
      containerEl.style.paddingTop = 0;
      //containerEl.style.display = 'none';

      if (clonedObject) {
        const resultHeaderEl = clonedObject.getElementsByClassName('result_header');
        const resultHeaderInnerEl = clonedObject.getElementsByClassName('result_header_inner');
        const contentsSummaryInnerEl = clonedObject.getElementsByClassName('contents_summary_inner');
        const contentsEl = clonedObject.getElementsByClassName('contents');
        const utilWrapEl = clonedObject.getElementsByClassName('util_wrap');
        const moveTopEl = clonedObject.getElementsByClassName('move_to_top');
        const pageEle = clonedObject.getElementsByClassName('clar_pagination');
        const footerEl = clonedObject.getElementsByClassName('footer');
        let tableEl;
        if (viewMode === 'list') {
          tableEl = clonedObject.getElementsByClassName('wide_card_box');
        } else {
          tableEl = clonedObject.getElementsByClassName('content_project_card_box');
        }

        if (resultHeaderEl.length !== 0) {
          resultHeaderEl[0].style.top = 0;
        }

        if (resultHeaderInnerEl.length !== 0) {
          resultHeaderInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsSummaryInnerEl.length !== 0) {
          contentsSummaryInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsEl.length !== 0) {
          contentsEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (utilWrapEl.length !== 0) {
          while (utilWrapEl.length > 0) {
            utilWrapEl[0].parentNode.removeChild(utilWrapEl[0]);
          }
        }

        if (moveTopEl.length !== 0) {
          while (moveTopEl.length > 0) {
            moveTopEl[0].parentNode.removeChild(moveTopEl[0]);
          }
        }

        if (pageEle.length !== 0) {
          while (pageEle.length > 0) {
            pageEle[0].parentNode.removeChild(pageEle[0]);
          }
        }

        if (footerEl.length !== 0) {
          while (footerEl.length > 0) {
            footerEl[0].parentNode.removeChild(footerEl[0]);
          }
        }

        //wide_card_box wide_card_type_01
        if (viewMode === 'list' && tableEl.length > 16) {
          let i = 0;
          for (i; i < tableEl.length; i++) {
            if ((i === 15 && tableEl.length > 16) || (i > 15 && (i - 15) % 19 === 0)) {
              tableEl[i].classList.add('page-break');
            }
          }
        }

        if (viewMode === 'card' && tableEl.length > 21) {
          let i = 0;
          for (i; i < tableEl.length; i++) {
            if (i === 20 || (i > 20 && (i - 20) % 28 === 0)) {
              tableEl[i].classList.add('page-break');
            }
          }
        }
      }

      document.body.appendChild(clonedObject);

      this.setState({
        pdfElement: clonedObject,
        isRendering: true,
      });
    }
  };

  generatePdfCallback = () => {
    const { pdfElement } = this.state;

    document.body.removeChild(pdfElement);
    this.setState({
      pdfElement: '',
      isRendering: false,
    });
  };

  move = (source) => {
    /*right */
    this.setState({
      selectedRightData: source[0],
      isSetRight: true,
    });
  };

  toggleViewMode = (value) => {
    this.setState({
      viewMode: value,
      currentPage: 1,
      searchKeyword: '',
      isSelectable: false,
      uploadedFiles: [],
      checkValues: [],
      isCheckAll: false,
    }, () => {
      this.getReportsList();
    });
  };

  toggleBookmarkOnList = (uid) => {
    api.toggleBookmark(
      {
        uploaded_file_id: uid,
        view_point: 'overview',
      }
    )
      .then((response) => {
        const res = response.response;
        this.handleCardBookmarkChange(uid, res.is_bookmark);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  toggleSelectMode = (value) => {
    this.setState({
      isSelectable: value,
      checkValues: [],
      isCheckAll: false,
    });
  };

  updateHistoryStatus = () => {
    const { state } = this.props;
    const statusObj = toJS(state.pages.statusObj);

    this.setState({
      searchKeyword: statusObj.searchKeyword,
      filter: statusObj.filter.slice(),
      radioValue: statusObj.radioValue,
      sortColumn: statusObj.sortColumn,
      uploadedFiles: statusObj.uploadedFiles.slice(),
      viewMode: statusObj.viewMode,
      pageSize: statusObj.pageSize,
      totalCount: statusObj.totalCount,
    }, () => {
      this.updateAutoScroll();
    });
  };

  initHistoryStatus = () => {
    const { location, state } = this.props;
    const { pathname } = location;

    state.pages.initScrollData(pathname);
    state.pages.initStatusData();
    setTimeout(() => {
      this.getReportsList();
    }, 500);
  };

  updateAutoScroll = () => {
    const { state, location } = this.props;
    const { pathname } = location;
    const scrollData = toJS(state.pages.scrollData);
    setTimeout(window.scrollTo({ left: 0, top: scrollData[pathname].offset }));
  };

  updateFilePath = (obj, id) => {
    const { uploadedFiles } = this.state;

    const updatedIndex = uploadedFiles.findIndex((item) => { return item.uid === id; });

    if (updatedIndex === -1) {
      console.warn(`Uploaded file with ID ${id} not found.`);
      return;
    }

    this.setState((prevState) => {
      const newUploadedFiles = [
        ...prevState.uploadedFiles.slice(0, updatedIndex),
        {
          ...prevState.uploadedFiles[updatedIndex],
          projectName: obj.selectedProject.name,
          projectVersionName: obj.selectedProjectVersion.name,
          pid: obj.selectedProject.id,
          pvi: obj.selectedProjectVersion.id,
        },
        ...prevState.uploadedFiles.slice(updatedIndex + 1),
      ];

      return {
        uploadedFiles: newUploadedFiles,
      };
    });
  };

  generateToken = (length) => {
    let i = 0;
    let result = '';
    const timeStamp = new Date();
    const components = [
      timeStamp.getYear(),
      timeStamp.getMonth(),
      timeStamp.getDate(),
      timeStamp.getHours(),
      timeStamp.getMinutes(),
      timeStamp.getSeconds(),
      timeStamp.getMilliseconds(),
    ];
    const id = components.join('');
    const charactersLength = id.length;

    for (i; i < length; i++) {
      result += id.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  };

  clearValue = (tagValue, tagname) => {
    const { filter } = this.state;
    const {
      navigate, location, state
    } = this.props;
    let newState;

    if (filter.indexOf(tagValue) > -1 && tagname === 'undefined') {
      newState = filter.filter((el) => {
        return el !== tagValue;
      });
    } else {
      newState = [];
    }

    if (tagname) {
      state.pages.setURLparamsWithUploadedFiles([]);
      navigate({
        pathname: location.pathname,
        search: '',
      });
    }

    this.setState(
      {
        uploadedFiles: [],
        filter: newState,
        checkValues: [],
        isCheckAll: false,
      },
      () => {
        this.getReportsList();
      }
    );
  };

  clearRadioValue = () => {
    this.setState(
      {
        uploadedFiles: [],
        startDate: '',
        endDate: '',
        radioValue: 'udtime_any',
        checkValues: [],
        isCheckAll: false,
      },
      () => {
        this.getReportsList();
      }
    );
  };

  clearAllValue = () => {
    const {
      navigate, location, state
    } = this.props;
    const filteredFileId = [];
    state.pages.setURLparamsWithUploadedFiles(filteredFileId);
    navigate({
      pathname: location.pathname,
      search: '',
    });
    this.setState(
      {
        uploadedFiles: [],
        filter: [],
        startDate: '',
        endDate: '',
        radioValue: 'udtime_any',
        checkValues: [],
        isCheckAll: false,
      },
      () => {
        this.getReportsList();
      }
    );
  };

  updateFileStatus = (uid) => {
    const { t } = this.props;
    const { uploadedFiles } = this.state;
    const cloneArray = [...uploadedFiles];

    const targetFileIndex = cloneArray.findIndex((item) => { return item.uid === uid; });

    if (targetFileIndex === -1) {
      console.error(`File with uid ${uid} not found`);
      return;
    }

    cloneArray[targetFileIndex].scanStatus = 1;
    cloneArray[targetFileIndex].scanStatusDetail = t('modal.new_scan.title.refresh_security');

    this.setState({
      uploadedFiles: cloneArray,
    });
  };

  rescanReport = (uid) => {
    const { t } = this.props;
    this.onUpdateStop();
    this.onUpdateStateChange('stop');
    this.isPausedUpdate = true;

    api
      .rescanReport(uid)
      .then(() => {
        this.updateFileStatus(uid);
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;
        if (o.error === '422-242') {
          this.modalAction = t('modal.title.attention');
          this.modalBody = t('modal.new_scan.error.error_422_242_rescan');
          this.setState({
            isOpenAlertModal: true,
          });
        } else if (o.error === '422-401') {
          this.modalAction = t('modal.title.attention');
          this.modalBody = t('modal.new_scan.error.error_422_401');
          this.setState({
            isOpenAlertModal: true,
          });
        }
      });
  };

  refreshSecurityReport = (uid) => {
    const { t } = this.props;
    this.onUpdateStop();
    this.onUpdateStateChange('stop');
    this.isPausedUpdate = true;

    api
      .refreshSecurityReport(uid)
      .then(() => {
        this.updateFileStatus(uid);
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;
        if (o.error === '422-242') {
          this.modalAction = t('modal.title.attention');
          this.modalBody = t('modal.new_scan.error.error_422_242_refresh');
          this.setState({
            isOpenAlertModal: true,
          });
        }
      });
  };

  removeProjectFilter = () => {
    const { state } = this.props;
    state.pages.initURLparams();
    this.setState({
      currentPage: 1,
      searchKeyword: '',
      isSelectable: false,
      uploadedFiles: [],
      checkValues: [],
      queryString: '',
    }, () => {
      this.getReportsList();
    });
  };

  closeExportModal = () => {
    this.setState({
      modalExportIsOpen: false,
      isDownloadingReport: false,
      toExport: '',
    });
  };

  clearSearch = () => {
    this.setState(
      {
        searchKeyword: '',
        uploadedFiles: [],
      },
      () => {
        this.getReportsList();
      }
    );
  };

  removeCurrentFile = (string) => {
    if (string === 'left') {
      this.setState({
        isSetLeft: false,
        selectedLeftData: {},
      });
    } else {
      this.setState({
        isSetRight: false,
        selectedRightData: {},
      });
    }
  };

  deletedCallback = (uid) => {
    this.setState((prevState) => {
      const newState = prevState.uploadedFiles.filter((item) => {
        return item.uid !== uid;
      });
      return {
        uploadedFiles: newState,
        isOpenAlert: false,
      };
    });
  };

  closeMoveFileModal = () => {
    this.setState({
      isOpenMFM: false,
      currentData: {},
    });
  };

  closeModal = () => {
    this.setState({
      currentData: {},
      currentUid: '',
      reportId: '',
      isOpenMSU: false,
      isOpenAlert: false,
      isOpenWarnModal: false,
      isOpenMCX: false,
      isOpenAlertModal: false,
      isOpenMCD: false,
      isOpenMNA: false,
      isOpenMVX: false,
      isOpenMSR: false,
      isOpenMCB: false,
    });
  };

  downloadReport = (exportFormat, exportType, toExport) => {
    const { t, state } = this.props;
    const { currentPrecisionLevel } = state.user;
    const { currentData } = this.state;
    const token = this.generateToken(10);
    const downloadFormatMapping = {
      [REPORT_EXTENSION_CSV]: 'csv',
      [REPORT_EXTENSION_EXCEL]: 'xlsx',
      [REPORT_EXTENSION_JSON]: 'zip',
    };
    let type;
    let url;

    if (currentPrecisionLevel) {
      type = currentPrecisionLevel;
    } else {
      type = null;
    }

    if (type) {
      url = `/1/reports/${
        currentData.uid
      }/export?file_format=${exportFormat}&section=${exportType}&token=${token}&precision_level=${type}&export_to=${toExport}`;
    } else {
      url = `/1/reports/${
        currentData.uid
      }/export?file_format=${exportFormat}&section=${exportType}&token=${token}&export_to=${toExport}`;
    }

    this.setState({
      isDownloadingReport: true
    });

    api
      .getExportedReport(url)
      .then((res) => {
        let data;
        let confidenceLevelName;
        const blob = new Blob([res], { type: 'application/octet-stream' });

        if (currentData.precisionLevel === 'narrow') {
          confidenceLevelName = 'high';
        } else if (currentData.precisionLevel === 'broad') {
          confidenceLevelName = 'low';
        } else {
          confidenceLevelName = currentData.precisionLevel;
        }
        const fileName = `${currentData.name}_${confidenceLevelName}.${downloadFormatMapping[exportFormat]}`;

        this.modalAction = t('modal.title.notice');

        if (toExport === 's3') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { bucket, key } = data.response;
          this.modalBody = t('modal.message.export_send_s3');
          this.modalHeader = (
            <p className="modal_list" style={{ paddingTop: '10px' }}>
              <b>{t('modal.title.bucket')}</b>
              &nbsp;
              {bucket}
            </p>
          );
          this.modalSubBody = (
            <p className="modal_list">
              <b>{t('modal.title.file_storage_path')}</b>
              &nbsp;
              {key}
            </p>
          );
        } else if (toExport === 'email') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { dest_email } = data.response;
          this.modalBody = t('modal.message.export_send_email');
          this.modalHeader = t('modal.message.export_send_to_email', { email: dest_email });
          this.modalSubBody = null;
        } else if (toExport === 'local') {
          FileSaver.saveAs(blob, fileName);
          this.modalBody = t('modal.message.export_send_local');
          this.modalHeader = null;
          this.modalSubBody = null;
        }
        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
          toExport,
        });
      })
      .catch((err) => {
        console.log(err);
        let jsonParse;
        const ArrayBufferView = Object.getPrototypeOf(Object.getPrototypeOf(new Uint8Array())).constructor;
        if (err.data instanceof ArrayBuffer || err.data instanceof ArrayBufferView) {
          jsonParse = JSON.parse(new TextDecoder().decode(err.data));
        } else {
          jsonParse = err.data;
        }
        const o = jsonParse.response;
        this.modalAction = t('modal.title.attention');

        if (!o.error) {
          this.modalBody = t('modal.error.unknow_error');
        }

        if (o.error === '422-002') { // recovery email
          this.modalBody = t('modal.error.error_422_002_export');
        }

        if (o.error === '422-365') { // license expired
          this.modalBody = t('system.message.license_expired');
        }

        if (o.error === '422-366') {
          this.modalBody = o.error_description;
        }

        if (o.error === '422-367') { // smtp error
          this.modalBody = t('modal.error.error_422_368_jira');
        }

        if (o.error === '422-791') {
          this.modalBody = t('modal.error.error_422_791_export');
        }

        this.modalHeader = null;
        this.modalSubBody = null;

        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
        });
      });
  };

  closeMenu = () => {
    this.setState({
      isOpenCompare: false,
    });
  };

  renderValue = () => {
    const { t, searchParams } = this.props;
    const {
      filter, radioValue, uploadedFiles, startDate, endDate
    } = this.state;
    const [URLSearchParams] = searchParams;
    let fileItemFilter = [];

    if (location.search.indexOf('uploaded_file_id') !== -1) {
      const uploaded_file_ids = URLSearchParams.getAll('uploaded_file_id');
      fileItemFilter = uploadedFiles.filter((item) => {
        return uploaded_file_ids.includes(item.uid.toString());
      });
    }

    const scanStatusFilter = filter.filter((item) => {
      return item.indexOf('rstatus') > -1;
    });

    const scanMethodFilter = filter.filter((item) => {
      return item.indexOf('smethod') > -1;
    });

    const gradeFilter = filter.filter((item) => {
      return item.indexOf('grade') > -1;
    });

    const securityFilter = filter.filter((item) => {
      return item.indexOf('security') > -1;
    });

    const licenseFilter = filter.filter((item) => {
      return item.indexOf('license') > -1;
    });

    const litigatorFilter = filter.filter((item) => {
      return item.indexOf('litigator') > -1;
    });

    const policyFilter = filter.filter((item) => {
      return item.indexOf('policy') > -1;
    });

    const leakageFilter = filter.filter((item) => {
      return item.indexOf('leakage') > -1;
    });

    const uploadedDateFilter = radioValue;

    const filterObj = {
      scanStatus: scanStatusFilter,
      scanMethod: scanMethodFilter,
      grade: gradeFilter,
      security: securityFilter,
      license: licenseFilter,
      litigator: litigatorFilter,
      policy: policyFilter,
      datetime: uploadedDateFilter,
      leakage: leakageFilter,
      upladedFiles: fileItemFilter,
    };

    return (
      <div>
        {filterObj.scanStatus.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('card.menu.scan_status')}</strong>
            </span>
            {filterObj.scanStatus.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_qu') > -1 && t('card.menu.queue')}
                  {item.indexOf('_sc') > -1 && t('card.menu.scanning')}
                  {item.indexOf('_su') > -1 && t('card.menu.success')}
                  {item.indexOf('_fa') > -1 && t('card.menu.fail')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}
        {filterObj.scanMethod.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('contents_header.link_header.scan_method')}</strong>
            </span>
            {filterObj.scanMethod.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_c') > -1 && t('contents_header.link_header.clarity_scan')}
                  {item.indexOf('_s') > -1 && t('contents_header.link_header.sbom_import')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.grade.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('card.menu.grade')}</strong>
            </span>
            {filterObj.grade.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_a') > -1 && 'A'}
                  {item.indexOf('_b') > -1 && 'B'}
                  {item.indexOf('_c') > -1 && 'C'}
                  {item.indexOf('_d') > -1 && 'D'}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.security.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('card.menu.security_lowercase')}</strong>
            </span>
            {filterObj.security.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_c') > -1 && t('project.menu.critical')}
                  {item.indexOf('_h') > -1 && t('project.menu.high')}
                  {item.indexOf('_m') > -1 && t('project.menu.medium')}
                  {item.indexOf('_l') > -1 && t('project.menu.low')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.license.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('card.menu.license')}</strong>
            </span>
            {filterObj.license.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_pt') > -1 && t('card.menu.protective')}
                  {item.indexOf('_pm') > -1 && t('card.menu.permissive')}
                  {item.indexOf('_o') > -1 && t('card.menu.others')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.litigator.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('card.menu.litigator')}</strong>
            </span>
            {filterObj.litigator.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_a') > -1 && t('card.menu.applicable')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}
        {filterObj.leakage.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('modal.leakage_info.leakage')}</strong>
            </span>
            {filterObj.leakage.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_a') > -1 && t('card.menu.applicable')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.policy.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('card.menu.violated_policy_lowercase')}</strong>
            </span>
            {filterObj.policy.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_a') > -1 && t('card.menu.applicable')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.datetime.indexOf('udtime_any') === -1 && (
          <Label.Group>
            <span>
              <strong>{t('project.menu.date')}</strong>
            </span>
            <Label as="a">
              {filterObj.datetime.indexOf('udtime_p24') > -1 && t('project.menu.past_24_hours')}
              {filterObj.datetime.indexOf('udtime_pw') > -1 && t('project.menu.past_week')}
              {filterObj.datetime.indexOf('udtime_pm') > -1 && t('project.menu.past_month')}
              {filterObj.datetime.indexOf('udtime_cr') > -1
                  && `${startDate}~${endDate}`}
              <Icon
                name="close"
                onClick={() => {
                  return this.clearRadioValue();
                }}
              />
            </Label>
          </Label.Group>
        )}

        {filterObj.upladedFiles.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('card.menu.filterd_file')}</strong>
            </span>
            <Label className="uploaded_files" as="a" key={uuidv4()}>
              <span>{filterObj.upladedFiles[0].name}</span>
              <Icon
                name="close"
                onClick={() => {
                  return this.clearValue(filterObj.upladedFiles, 'uploaded_file');
                }}
              />
            </Label>
          </Label.Group>
        )}
        {filter.length !== 0 || radioValue.indexOf('udtime_any') === -1 ? (
          <div
            className="clear_all"
            onClick={() => {
              return this.clearAllValue();
            }}
            onKeyUp={() => {
              return this.clearAllValue();
            }}
          >
            {t('project.menu.clear_all_filters')}
          </div>
        ) : null}
      </div>
    );
  };

  renderMoveMenu = (current) => {
    const { t } = this.props;
    const { scanStatus, hasPermission } = current;

    if (scanStatus !== 2) {
      return (
        <a
          style={{
            cursor: 'default',
            opacity: '.45',
            color: '#dddddd',
          }}
        >
          <img src={moveFileIcon} alt="" />
          {t('card.menu.move')}
        </a>
      );
    }
    if (!hasPermission) {
      return (
        <a
          style={{
            cursor: 'default',
            opacity: '.45',
            color: '#dddddd',
          }}
        >
          <img src={moveFileIcon} alt="" />
          {t('card.menu.move')}
        </a>
      );
    }
    return (
      <a
        onClick={() => { return this.handleMove(current); }}
        onKeyUp={() => { return this.handleMove(current); }}
      >
        <img src={moveFileIcon} alt="" />
        {t('card.menu.move')}
      </a>
    );
  };

  renderScanStatus = (file, i) => {
    const { t } = this.props;
    const {
      scanStatus, hasLeakage, isRescanned, isScanning
    } = file;
    const { checkValues } = this.state;
    const iconStyle = {
      width: '14px',
      height: '14px',
      color: '#969696',
      fontWeight: 'bold',
      fontSize: '12px',
      marginRight: '5px',
    };

    return (
      <tr>
        <td className="checkbox_wrap border-none tac">
          <Checkbox
            className="select_mode"
            value={file.uid}
            checked={checkValues.indexOf(file.uid) > -1}
            onChange={this.handleCheckChange}
            disabled={!file.hasPermission}
          />
        </td>
        <td className="border-none tal file_name">
          <div>
            <p
              className="file_name scan"
            >
              {file.useScanOption ? (<img src={quickScan} alt="" />) : null}
              {file.hasBundled ? (<img src={jsBundled} alt="" />) : null}
              <span
                className="none_link"
              >
                {file.name}
              </span>
            </p>
            <p className="project_name">
              <span>{file.projectName}</span>
              <span>/</span>
              <span>{file.projectVersionName}</span>
            </p>
          </div>
        </td>
        <td className="border-none tac" colSpan="7">
          {
            scanStatus === 0
            && (
              <div className="scan_file">
                <img src={scanQueue} alt="" />
                <span className="text">{t('card.menu.queue')}</span>
              </div>
            )
          }
          {
            scanStatus === 1
            && (
              <div className="" style={{ display: 'table', margin: '0 40%' }}>
                <Loader active size="small" style={{ display: 'table-cell' }} />
                <div className="scan_detail">
                  <span>{file.scanStatusDetail}</span>
                </div>
              </div>
            )
          }
          {
            scanStatus === 3
            && (
              <div className="scan_file">
                <img src={scanFailIcon} alt="" />
                <span className="text">{t('modal.title.scan_failed')}</span>
              </div>
            )
          }
        </td>
        <td className="border-none tac">
          <a
            className="more_row"
            onClick={() => { return this.handleMoreMenu(i); }}
            onKeyUp={() => { return this.handleMoreMenu(i); }}
          >
            <img src={moreBtn} alt="more" />
          </a>
          <div className="more_menu">
            {isRescanned ? (
              <p className="noti">
                <a
                  onClick={() => { return this.handleSecurityInfoItem(file.uid); }}
                  onKeyUp={() => { return this.handleSecurityInfoItem(file.uid); }}
                >
                  <img src={newIcon} alt="" />
                  {t('card.menu.security_risk_updated')}
                </a>
              </p>
            ) : null}
            <ul>
              {
                (scanStatus === 2 || scanStatus === 3)
                && (
                  <li>
                    <a
                      onClick={() => { return this.handleInfoItem(file.uid); }}
                      onKeyUp={() => { return this.handleInfoItem(file.uid); }}
                    >
                      <Icon name="info" style={{ color: '#969696' }} />
                      {t('card.menu.information')}
                    </a>
                  </li>
                )
              }
              {
                hasLeakage ? (
                  <li>
                    <a
                      onClick={() => { return this.handleLeakageList(file.uid, file.name); }}
                      onKeyUp={() => { return this.handleLeakageList(file.uid, file.name); }}
                    >
                      <Icon name="shield" style={{ color: '#969696' }} />
                      {t('card.menu.leakage')}
                    </a>
                  </li>
                ) : null
              }
              <li>
                <a
                  style={{
                    cursor: 'default',
                    opacity: '.45',
                    color: '#dddddd',
                  }}
                >
                  <img src={compareBtn} alt="" />
                  {t('card.menu.compare')}
                </a>
              </li>
              <li>
                {this.renderMoveMenu(file)}
              </li>
              <li>
                {
                  scanStatus !== 2 || file.componentCountBroad.total === 0 ? (
                    <a
                      style={{
                        cursor: 'default',
                        opacity: '.45',
                        color: '#dddddd',
                      }}
                    >
                      <Icon name="bookmark outline" style={iconStyle} />
                      {t('card.menu.bookmark')}
                    </a>
                  ) : (
                    <a
                      onClick={() => { return this.toggleBookmarkOnList(file.uid); }}
                      onKeyUp={() => { return this.toggleBookmarkOnList(file.uid); }}
                    >
                      {
                        file.isBookmark ? (
                          <Icon name="bookmark" style={iconStyle} />
                        ) : (
                          <Icon name="bookmark outline" style={iconStyle} />
                        )
                      }
                      {t('card.menu.bookmark')}
                    </a>
                  )
                }
              </li>
              <li>
                <a
                  className="sbom"
                  style={{
                    cursor: 'default',
                    opacity: '.45',
                    color: '#dddddd',
                  }}
                >
                  <img src={exportIcon} alt="" />
                  SBOM
                </a>
              </li>
              {
                (scanStatus === 2 || scanStatus === 3)
                && (
                  <li>
                    {
                      scanStatus === 3
                    && (
                      <a
                        onClick={() => { return this.rescanReport(file.uid); }}
                        onKeyUp={() => { return this.rescanReport(file.uid); }}
                      >
                        <Icon name="refresh" style={iconStyle} />
                        {t('modal.new_scan.title.rescan')}
                      </a>
                    )
                    }
                    {
                      scanStatus === 2
                    && (
                      <a
                        onClick={() => { return this.refreshSecurityReport(file.uid); }}
                        onKeyUp={() => { return this.refreshSecurityReport(file.uid); }}
                      >
                        <Icon name="refresh" style={iconStyle} />
                        {t('modal.new_scan.title.refresh_security')}
                      </a>
                    )
                    }
                  </li>
                )
              }
              {
                (scanStatus === 2 && !isScanning)
                && (
                  <li>
                    <a
                      onClick={() => { return this.handleAddScanResults(file.uid); }}
                      onKeyUp={() => { return this.handleAddScanResults(file.uid); }}
                    >
                      <Icon name="add" style={iconStyle} />
                      {t('card.menu.add_scan_result')}
                    </a>
                  </li>
                )
              }
              <li>
                {file.hasPermission ? (
                  <a
                    onClick={() => { return this.handleDeleteOnList(file); }}
                    onKeyUp={() => { return this.handleDeleteOnList(file); }}
                  >
                    <img src={deleteIcon} alt="" />
                    {t('card.menu.delete')}
                  </a>
                ) : (
                  <a
                    style={{
                      cursor: 'default',
                      opacity: '.45',
                      color: '#dddddd',
                    }}
                  >
                    <img src={deleteIcon} alt="" />
                    {t('card.menu.delete')}
                  </a>
                )}
              </li>
            </ul>
          </div>
        </td>
      </tr>
    );
  };

  render() {
    let useLeakage;
    const {
      error,
      hasMore,
      isLoading,
      uploadedFiles,
      filter,
      radioValue,
      scanInfoUid,
      searchKeyword,
      sortColumn,
      viewMode,
      isSort,
      sortValue,
      currentPage,
      totalPage,
      pageSize,
      isSelectable,
      isCheckAll,
      checkValues,
      isResizeHeaeder,
      activePage,
      pdfElement,
      selectedLeftData,
      selectedRightData,
      isOpenWarnModal,
      startDate,
      endDate,
      isOpenAlertModal,
      toExport,
      isShowSbom,
      isOpenMNA,
      activeMenuIndex,
      isOpenCompare,
      isSetLeft,
      isSetRight,
      isRendering,
      isMovingFile,
      isOpenMSU,
      currentUid,
      isOpenAlert,
      currentData,
      isOpenMCX,
      reportId,
      isOpenMCD,
      isOpenCPM,
      isCompareLoading,
      compareResult,
      isOpenMSI,
      isOpenMLK,
      selectedUid,
      selectedName,
      modalExportIsOpen,
      isDownloadingReport,
      isOpenMFM,
      uploadedFileName,
      totalCount,
      isOpenMVX,
      isOpenMSR,
      isOpenMCB,
    } = this.state;

    const {
      state,
      location,
      params,
      t,
      navigate,
    } = this.props;

    const { isOpenNewScan, isReloadList } = state.report;

    const { use_leakage } = state.user;

    const getBooleanUseLeakage = localStorage.getItem('use_leakage') === 'true';

    if (use_leakage !== getBooleanUseLeakage) {
      useLeakage = getBooleanUseLeakage;
    } else {
      useLeakage = use_leakage;
    }

    this.isOpenNewScan = isOpenNewScan;
    this.isReloadList = isReloadList;

    const getListStyle = (isDraggingOver) => {
      if (isDraggingOver) {
        return {
          background: '#f5f4ff',
          opacity: 0.8,
          transitionDuration: '0.001s',
          overflow: 'hidden',
        };
      }
    };

    const humanReadable = (seconds) => {
      const pad = (x) => {
        return x < 10 ? '0'.concat(x) : ''.concat(x);
      };
      return pad(parseInt(seconds / (60 * 60), 10)).concat(
        ':',
        pad(parseInt((seconds / 60) % 60, 10)),
        ':',
        pad(seconds % 60)
      ); // eslint-disable-line no-unused-vars
    };

    const iconStyle = {
      width: '14px',
      height: '14px',
      color: '#969696',
      fontWeight: 'bold',
      fontSize: '12px',
      marginRight: '5px',
    };

    return (
      <div>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <ContentsHeaderWithResultAll
            onChangeSearch={this.handleChange}
            onChangeSorting={this.handleChangeSorting}
            onSubmit={this.handleFilterData}
            clearSearch={this.clearSearch}
            removeCurrentFile={this.removeCurrentFile}
            filter={filter}
            radioValue={radioValue}
            searchKeyword={searchKeyword}
            sortColumn={sortColumn}
            viewMode={viewMode}
            pageSize={pageSize}
            isSelectable={isSelectable}
            isCheckAll={isCheckAll}
            checkValues={checkValues}
            isResizeHeaeder={isResizeHeaeder}
            isSetLeft={isSetLeft}
            isSetRight={isSetRight}
            selectedLeftData={selectedLeftData}
            selectedRightData={selectedRightData}
            isOpenCompare={isOpenCompare}
            handleCompareChange={this.handleCompareChange}
            handlePageSizeChange={this.handlePageSizeChange}
            toggleViewMode={this.toggleViewMode}
            toggleSelectMode={this.toggleSelectMode}
            toggleCheckChange={this.handleCheckAllChange}
            handleDeleteChange={this.handleDeleteChange}
            closeMenu={this.closeMenu}
            refElement={pdfElement}
            isRendering={isRendering}
            createElementWithCanvas={this.createElementWithCanvas}
            generatePdfCallback={this.generatePdfCallback}
            location={location}
            state={state}
            params={params}
            translate={t}
            useLeakage={useLeakage}
            startDate={startDate}
            endDate={endDate}
            navigate={navigate}
            totalCount={totalCount}
            handleSearchChange={this.handleSearchChange}
          />
          {
            viewMode === 'card' ? (
              <div className="content">
                {filter.length !== 0 || radioValue.indexOf('udtime_any') === -1 || location.search.indexOf('uploaded_file_id') !== -1 ? (
                  <div className="tag_list">{this.renderValue()}</div>
                ) : null}
                <Droppable droppableId="droppableCard" isDropDisabled direction="horizontal">
                  {(provided, snapshot) => {
                    return (
                      <div
                        className="content_files_list"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                      >
                        {uploadedFiles.length !== 0
                          ? uploadedFiles.map((file, index) => {
                            return (
                              <Draggable
                                key={file.uid}
                                draggableId={file.uid.toString()}
                                index={index}
                                isDragDisabled={!isOpenCompare || file.scanStatus !== 2}
                              >
                                {(draggableProvided, draggableSnapshot) => {
                                  return (
                                    <UploadedFileCard
                                      key={file.uid}
                                      file={file}
                                      isSelectable={isSelectable}
                                      checkValues={checkValues}
                                      clickEvent={this.handleClick}
                                      handleChangeView={this.handleChangeView}
                                      deletedCallback={this.deletedCallback}
                                      handleCardBookmarkChange={this.handleCardBookmarkChange}
                                      updateFilePath={this.updateFilePath}
                                      draggableProvided={draggableProvided}
                                      draggableSnapshot={draggableSnapshot}
                                      setCompareItem={this.setCompareItem}
                                      handleInfoItem={this.handleInfoItem}
                                      handleLeakageList={this.handleLeakageList}
                                      handleCheckChange={this.handleCheckChange}
                                      handleIssueCallback={this.handleIssueCallback}
                                      rescanReport={this.rescanReport}
                                      refreshSecurityReport={this.refreshSecurityReport}
                                      handleSaveCallback={this.handleSaveCallback}
                                      translate={t}
                                      location={location}
                                    />
                                  );
                                }}
                              </Draggable>
                            );
                          })
                          : null}
                        {provided.placeholder}
                      </div>
                    );
                  }}
                </Droppable>
                {error && <div style={{ color: '#900' }}>{error}</div>}
                <div style={{ paddingBottom: '14px' }}>
                  <Loader active={isLoading} inline="centered" />
                </div>
                {!hasMore && <Footer />}
              </div>
            ) : (
              <div className="content">
                {filter.length !== 0 || radioValue.indexOf('udtime_any') === -1 || location.search.indexOf('uploaded_file_id') !== -1 ? (
                  <div className="tag_list">{this.renderValue()}</div>
                ) : null}
                {
                  isLoading ? (
                    <div style={{ paddingBottom: '14px' }}>
                      <Loader active={isLoading} inline="centered" />
                    </div>
                  ) : (
                    <div className="content_projects_List">
                      <div className="wide_card_wrap">
                        <div className="table_header">
                          <div className="table_header_inner">
                            <table className="wide_card_table wide_card_scope">
                              <colgroup>
                                <col style={{ width: '3.9%', maxWidth: '36px' }} />
                                <col style={{ width: '13%', maxWidth: '120px' }} />
                                <col style={{ width: '4.5%' }} />
                                <col style={{ width: '8%' }} />
                                <col style={{ width: '43.7%' }} />
                                <col style={{ width: '5.5%' }} />
                                <col style={{ width: '6.15%' }} />
                                <col style={{ width: '6.65%' }} />
                                <col style={{ width: '4.3%', maxWidth: '40px' }} />
                                <col style={{ width: '4.3%', maxWidth: '40px' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <th>
                                    <Checkbox
                                      className="select_mode"
                                      checked={isCheckAll}
                                      onChange={this.handleCheckAllChange}
                                    />
                                  </th>
                                  <th className="tal">
                                    <a
                                      className="sorting_button"
                                      data-id="1"
                                      onClick={this.handleListSortingChange}
                                      onKeyUp={this.handleListSortingChange}
                                    >
                                      {t('list.title.name')}
                                      {isSort && sortValue === '1' ? <img src={upIcon} alt="" /> : ''}
                                      {!isSort && sortValue === '1' ? <img src={downIcon} alt="" /> : ''}
                                    </a>
                                  </th>
                                  <th className="tac">
                                    <a
                                      className="sorting_button"
                                      data-id="2"
                                      onClick={this.handleListSortingChange}
                                      onKeyUp={this.handleListSortingChange}
                                    >
                                      {t('list.title.grade')}
                                      {isSort && sortValue === '2' ? <img src={upIcon} alt="" /> : ''}
                                      {!isSort && sortValue === '2' ? <img src={downIcon} alt="" /> : ''}
                                    </a>
                                  </th>
                                  <th className="tac">
                                    <a
                                      className="sorting_button"
                                      data-id="3"
                                      onClick={this.handleListSortingChange}
                                      onKeyUp={this.handleListSortingChange}
                                    >
                                      {t('list.title.component')}
                                      {isSort && sortValue === '3' ? <img src={upIcon} alt="" /> : ''}
                                      {!isSort && sortValue === '3' ? <img src={downIcon} alt="" /> : ''}
                                    </a>
                                  </th>
                                  <th className="sum_th">
                                    <table>
                                      <colgroup>
                                        <col style={{ width: '41.4%' }} />
                                        <col style={{ width: '34.3%' }} />
                                        <col style={{ width: '12%' }} />
                                        <col style={{ width: '12.3%' }} />
                                      </colgroup>
                                      <tbody>
                                        <tr>
                                          <th className="tac">
                                            <a
                                              className="sorting_button"
                                              data-id="4"
                                              onClick={this.handleListSortingChange}
                                              onKeyUp={this.handleListSortingChange}
                                            >
                                              {t('list.title.security_risk')}
                                              {isSort && sortValue === '4' ? <img src={upIcon} alt="" /> : ''}
                                              {!isSort && sortValue === '4' ? <img src={downIcon} alt="" /> : ''}
                                            </a>
                                          </th>
                                          <th className="tac">
                                            <a
                                              className="sorting_button"
                                              data-id="5"
                                              onClick={this.handleListSortingChange}
                                              onKeyUp={this.handleListSortingChange}
                                            >
                                              {t('list.title.license')}
                                              {isSort && sortValue === '5' ? <img src={upIcon} alt="" /> : ''}
                                              {!isSort && sortValue === '5' ? <img src={downIcon} alt="" /> : ''}
                                            </a>
                                          </th>
                                          <th className="tac">
                                            <a
                                              className="sorting_button"
                                              data-id="6"
                                              onClick={this.handleListSortingChange}
                                              onKeyUp={this.handleListSortingChange}
                                            >
                                              {t('list.title.litigator')}
                                              {isSort && sortValue === '6' ? <img src={upIcon} alt="" /> : ''}
                                              {!isSort && sortValue === '6' ? <img src={downIcon} alt="" /> : ''}
                                            </a>
                                          </th>
                                          <th className="tac">
                                            <a
                                              className="sorting_button"
                                              data-id="7"
                                              onClick={this.handleListSortingChange}
                                              onKeyUp={this.handleListSortingChange}
                                            >
                                              {t('list.title.policy')}
                                              {isSort && sortValue === '7' ? <img src={upIcon} alt="" /> : ''}
                                              {!isSort && sortValue === '7' ? <img src={downIcon} alt="" /> : ''}
                                            </a>
                                          </th>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </th>
                                  <th className="tac">
                                    <a
                                      className="sorting_button"
                                      data-id="9"
                                      onClick={this.handleListSortingChange}
                                      onKeyUp={this.handleListSortingChange}
                                    >
                                      {t('list.title.owner')}
                                      {isSort && sortValue === '9' ? <img src={upIcon} alt="" /> : ''}
                                      {!isSort && sortValue === '9' ? <img src={downIcon} alt="" /> : ''}
                                    </a>
                                  </th>
                                  <th className="tac">
                                    <a
                                      className="sorting_button"
                                      data-id="8"
                                      onClick={this.handleListSortingChange}
                                      onKeyUp={this.handleListSortingChange}
                                    >
                                      {t('list.title.last_uploaded')}
                                      {isSort && sortValue === '8' ? <img src={upIcon} alt="" /> : ''}
                                      {!isSort && sortValue === '8' ? <img src={downIcon} alt="" /> : ''}
                                    </a>
                                  </th>
                                  <th className="tac">
                                    <a
                                      className="sorting_button"
                                      data-id="10"
                                      onClick={this.handleListSortingChange}
                                      onKeyUp={this.handleListSortingChange}
                                    >
                                      {t('list.title.scanned_time')}
                                      {isSort && sortValue === '10' ? <img src={upIcon} alt="" /> : ''}
                                      {!isSort && sortValue === '10' ? <img src={downIcon} alt="" /> : ''}
                                    </a>
                                  </th>
                                  <th>&nbsp;</th>
                                  <th>&nbsp;</th>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        {uploadedFiles.map((item, i) => {
                          return (
                            <div className="wide_card_box wide_card_type_01" key={item.uid}>
                              <table
                                className={cx(
                                  'wide_card_table wide_card_item list_view',
                                  {
                                    more_menu_show: activeMenuIndex === i,
                                  },
                                )}
                              >
                                <colgroup>
                                  <col style={{ width: '3.9%', maxWidth: '36px' }} />
                                  <col style={{ width: '13%', maxWidth: '120px' }} />
                                  <col style={{ width: '4.5%' }} />
                                  <col style={{ width: '8%' }} />
                                  <col style={{ width: '43.7%' }} />
                                  <col style={{ width: '5.5%' }} />
                                  <col style={{ width: '6.15%' }} />
                                  <col style={{ width: '6.65%' }} />
                                  <col style={{ width: '4.3%', maxWidth: '40px' }} />
                                  <col style={{ width: '4.3%', maxWidth: '40px' }} />
                                </colgroup>
                                <tbody>
                                  {
                                    item.scanStatus !== 2 ? (
                                      this.renderScanStatus(item, i)
                                    ) : (
                                      <tr>
                                        <td className="border-none tac">
                                          <Checkbox
                                            className="select_mode"
                                            value={item.uid}
                                            checked={checkValues.indexOf(item.uid) > -1}
                                            onChange={this.handleCheckChange}
                                            disabled={!item.hasPermission}
                                          />
                                        </td>
                                        {
                                          item.componentCountBroad.total !== 0 ? (
                                            <td className="border-none tal">
                                              <div>
                                                <p
                                                  className="file_name scan"
                                                >
                                                  {item.useScanOption ? (<img src={quickScan} alt="" />) : null}
                                                  {item.hasBundled ? (<img src={jsBundled} alt="" />) : null}
                                                  <span
                                                    className="has_link"
                                                    onClick={() => { return this.handleClick(item.uid); }}
                                                    onKeyUp={() => { return this.handleClick(item.uid); }}
                                                  >
                                                    {item.name}
                                                  </span>
                                                </p>
                                                <p className="project_name">
                                                  <span>{item.projectName}</span>
                                                  <span>/</span>
                                                  <span>{item.projectVersionName}</span>
                                                </p>
                                              </div>
                                            </td>
                                          ) : (
                                            <td className="border-none tal">
                                              <div>
                                                <p
                                                  className="file_name scan"
                                                >
                                                  {item.useScanOption ? (<img src={quickScan} alt="" />) : null}
                                                  {item.hasBundled ? (<img src={jsBundled} alt="" />) : null}
                                                  <span
                                                    className="none_link"
                                                  >
                                                    {item.name}
                                                  </span>
                                                </p>
                                                <p className="project_name">
                                                  <span>{item.projectName}</span>
                                                  <span>/</span>
                                                  <span>{item.projectVersionName}</span>
                                                </p>
                                              </div>
                                            </td>
                                          )
                                        }
                                        {
                                          item.componentCountBroad.total !== 0 ? (
                                            <td className="border-none tac rank">
                                              <span
                                                className="has_link"
                                                onClick={() => { return this.handleClick(item.uid); }}
                                                onKeyUp={() => { return this.handleClick(item.uid); }}
                                              >
                                                {item.uploadedGrade}
                                              </span>
                                            </td>
                                          ) : (
                                            <td className="border-none tac rank"><span className="none_link">{item.uploadedGrade}</span></td>
                                          )
                                        }
                                        {
                                          item.componentCountBroad.total !== 0 ? (
                                            <td className="border-none tac">
                                              <span
                                                className="has_link"
                                                onClick={() => { return this.handleChangeView(item.uid, 'component'); }}
                                                onKeyUp={() => { return this.handleChangeView(item.uid, 'component'); }}
                                              >
                                                <MiniPieChart chartData={item.componentCount} translate={t} />
                                              </span>
                                            </td>
                                          ) : (
                                            <td className="border-none tac">
                                              <span><MiniPieChart chartData={item.componentCount} translate={t} /></span>
                                            </td>
                                          )
                                        }
                                        <td className="sum_td">
                                          <table className="wide_card_table wide_card_item list_view">
                                            <colgroup>
                                              <col style={{ width: '41.4%' }} />
                                              <col style={{ width: '34.3%' }} />
                                              <col style={{ width: '12%' }} />
                                              <col style={{ width: '12.3%' }} />
                                            </colgroup>
                                            <tbody>
                                              <tr>
                                                <td className="tac">
                                                  {
                                                    item.securityCountBroad && item.securityCountBroad.total !== 0 ? (
                                                      <div
                                                        className="belt_chart has_link"
                                                        onClick={() => { return this.handleChangeView(item.uid, 'security'); }}
                                                        onKeyUp={() => { return this.handleChangeView(item.uid, 'security'); }}
                                                      >
                                                        <div className="red">
                                                          {item.securityCount.critical}
                                                        </div>
                                                        <div className="orange">
                                                          {item.securityCount.high}
                                                        </div>
                                                        <div className="cheese">
                                                          {item.securityCount.medium}
                                                        </div>
                                                        <div className="yellow">
                                                          {item.securityCount.low}
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      <div
                                                        className="belt_chart"
                                                        style={{ pointerEvents: 'none' }}
                                                      >
                                                        <div className="red">
                                                          {item.securityCount.critical}
                                                        </div>
                                                        <div className="orange">
                                                          {item.securityCount.high}
                                                        </div>
                                                        <div className="cheese">
                                                          {item.securityCount.medium}
                                                        </div>
                                                        <div className="yellow">
                                                          {item.securityCount.low}
                                                        </div>
                                                      </div>
                                                    )
                                                  }
                                                  {
                                                    item.hasExploit ? (<Icon name="bug" />) : null
                                                  }
                                                </td>
                                                <td className="tac">
                                                  {
                                                    item.licenseCountBroad && item.licenseCountBroad.total !== 0 ? (
                                                      <div
                                                        className="belt_chart round has_link"
                                                        onClick={() => { return this.handleChangeView(item.uid, 'license'); }}
                                                        onKeyUp={() => { return this.handleChangeView(item.uid, 'license'); }}
                                                      >
                                                        <div className="red">
                                                          {item.licenseCount.protective}
                                                        </div>
                                                        <div className="cheese">
                                                          {item.licenseCount.permissive}
                                                        </div>
                                                        <div className="yellow">
                                                          {item.licenseCount.others}
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      <div
                                                        className="belt_chart round"
                                                        style={{ pointerEvents: 'none' }}
                                                      >
                                                        <div className="red">
                                                          {item.licenseCount.protective}
                                                        </div>
                                                        <div className="cheese">
                                                          {item.licenseCount.permissive}
                                                        </div>
                                                        <div className="yellow">
                                                          {item.licenseCount.others}
                                                        </div>
                                                      </div>
                                                    )
                                                  }
                                                </td>
                                                <td
                                                  className="tac"
                                                  style={{
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                  }}
                                                >
                                                  {item.litigatorCount}
                                                </td>
                                                {
                                                  item.policyCountBroad !== 0 ? (
                                                    <td
                                                      className="tac has_link"
                                                      onClick={() => { return this.handleChangeView(item.uid, 'policy'); }}
                                                      style={{
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                      }}
                                                    >
                                                      {item.policyCount}
                                                    </td>
                                                  ) : (
                                                    <td
                                                      className="tac"
                                                      style={{
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        pointerEvents: 'none',
                                                      }}
                                                    >
                                                      {item.policyCount}
                                                    </td>
                                                  )
                                                }
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                        <td className="border-none tac">
                                          {item.owner}
                                        </td>
                                        <td className="border-none tac">
                                          {item.uploadedDate}
                                        </td>
                                        <td className="border-none tac">
                                          {humanReadable(item.scannedTime)}
                                        </td>
                                        <td className="border-none tac">
                                          {
                                            isOpenCompare ? (
                                              <a
                                                className="compare_row enable"
                                                onClick={() => { return this.setCompareItemOnList(item); }}
                                                onKeyUp={() => { return this.setCompareItemOnList(item); }}
                                              >
                                                <img src={compareBtn} alt="" />
                                              </a>
                                            ) : (
                                              <a
                                                className="compare_row"
                                                style={{ pointerEvents: 'none', opacity: '.45', color: '#dddddd' }}
                                              >
                                                <img src={compareBtn} alt="" />
                                              </a>
                                            )
                                          }
                                        </td>
                                        <td className="border-none tac">
                                          <a
                                            className="more_row"
                                            onClick={() => { return this.handleMoreMenu(i); }}
                                            onKeyUp={() => { return this.handleMoreMenu(i); }}
                                          >
                                            <img src={moreBtn} alt="more" />
                                          </a>
                                          <div className="more_menu">
                                            {item.isRescanned ? (
                                              <p className="noti">
                                                <a
                                                  onClick={() => { return this.handleSecurityInfoItem(item.uid); }}
                                                  onKeyUp={() => { return this.handleSecurityInfoItem(item.uid); }}
                                                >
                                                  <Icon name="info circle" />
                                                  {t('card.menu.security_risk_updated')}
                                                </a>
                                              </p>
                                            ) : null}
                                            <ul>
                                              {
                                                (item.scanStatus === 2 || item.scanStatus === 3)
                                              && (
                                                <li>
                                                  <a
                                                    onClick={() => { return this.handleInfoItem(item.uid); }}
                                                    onKeyUp={() => { return this.handleInfoItem(item.uid); }}
                                                  >
                                                    <Icon name="info" style={{ color: '#969696' }} />
                                                    {t('card.menu.information')}
                                                  </a>
                                                </li>
                                              )
                                              }
                                              {
                                                item.hasLeakage ? (
                                                  <li>
                                                    <a
                                                      onClick={() => { return this.handleLeakageList(item.uid, item.name); }}
                                                      onKeyUp={() => { return this.handleLeakageList(item.uid, item.name); }}
                                                    >
                                                      <Icon name="shield" style={{ color: '#969696' }} />
                                                      {t('card.menu.leakage')}
                                                    </a>
                                                  </li>
                                                ) : null
                                              }
                                              <li>
                                                {
                                                  item.scanStatus === 2 && item.componentCountBroad.total > 0 ? (
                                                    <a
                                                      onClick={() => { return this.setCompareItem(item); }}
                                                      onKeyUp={() => { return this.setCompareItem(item); }}
                                                    >
                                                      <img src={compareBtn} alt="" />
                                                      {t('card.menu.compare')}
                                                    </a>
                                                  ) : (
                                                    <a
                                                      style={{
                                                        cursor: 'default',
                                                        opacity: '.45',
                                                        color: '#dddddd',
                                                      }}
                                                    >
                                                      <img src={compareBtn} alt="" />
                                                      {t('card.menu.compare')}
                                                    </a>
                                                  )
                                                }
                                              </li>
                                              <li>
                                                {this.renderMoveMenu(item)}
                                              </li>
                                              <li>
                                                {
                                                  item.scanStatus !== 2 || item.componentCountBroad.total === 0 ? (
                                                    <a
                                                      style={{
                                                        cursor: 'default',
                                                        opacity: '.45',
                                                        color: '#dddddd',
                                                      }}
                                                    >
                                                      <Icon name="bookmark outline" style={iconStyle} />
                                                      {t('card.menu.bookmark')}
                                                    </a>
                                                  ) : (
                                                    <a
                                                      onClick={() => { return this.toggleBookmarkOnList(item.uid); }}
                                                      onKeyUp={() => { return this.toggleBookmarkOnList(item.uid); }}
                                                    >
                                                      {
                                                        item.isBookmark ? (
                                                          <Icon name="bookmark" style={iconStyle} />
                                                        ) : (
                                                          <Icon name="bookmark outline" style={iconStyle} />
                                                        )
                                                      }
                                                      {t('card.menu.bookmark')}
                                                    </a>
                                                  )
                                                }
                                              </li>
                                              {
                                                state.user.use_crypto && item.scanStatus === 2 ? (
                                                  <li>
                                                    <a
                                                      onClick={() => { return this.handleCBOM(item); }}
                                                      onKeyUp={() => { return this.handleCBOM(item); }}
                                                    >
                                                      <Icon name="download" style={iconStyle} />
                                                      CBOM
                                                    </a>
                                                  </li>
                                                ) : null
                                              }
                                              <li>
                                                {
                                                  item.scanStatus === 2 ? (
                                                    <a
                                                      className="sbom"
                                                      onClick={this.handleSlideToggle}
                                                      onKeyUp={this.handleSlideToggle}
                                                    >
                                                      <img src={exportIcon} alt="" />
                                                      SBOM
                                                    </a>
                                                  ) : (
                                                    <a
                                                      className="sbom"
                                                      style={{
                                                        cursor: 'default',
                                                        opacity: '.45',
                                                        color: '#dddddd',
                                                      }}
                                                    >
                                                      <img src={exportIcon} alt="" />
                                                      SBOM
                                                    </a>
                                                  )
                                                }
                                                <ul
                                                  className={cx(
                                                    'sub_menu',
                                                    {
                                                      active: isShowSbom,
                                                    },
                                                  )}
                                                >
                                                  <li style={{ padding: '0 0 0 20px' }}>
                                                    <a
                                                      onClick={() => { return this.handleExport(item); }}
                                                      onKeyUp={() => { return this.handleExport(item); }}
                                                    >
                                                      <Icon name="download" style={iconStyle} />
                                                      {t('card.menu.clarity')}
                                                    </a>
                                                  </li>

                                                  {item.scanStatus === 2 ? (
                                                    <>
                                                      <li style={{ padding: '0 0 0 20px' }}>
                                                        <a
                                                          onClick={() => { return this.handleSpdx(item.uid, item.name); }}
                                                          onKeyUp={() => { return this.handleSpdx(item.uid, item.name); }}
                                                        >
                                                          <Icon name="download" style={iconStyle} />
                                                          {t('card.menu.spdx')}
                                                        </a>
                                                      </li>
                                                      <li style={{ padding: '0 0 0 20px' }}>
                                                        <a
                                                          onClick={() => { return this.handleCycloneDx(item.uid); }}
                                                          onKeyUp={() => { return this.handleCycloneDx(item.uid); }}
                                                        >
                                                          <Icon name="download" style={iconStyle} />
                                                          CycloneDX
                                                        </a>
                                                      </li>
                                                      <li style={{ padding: '0 0 0 20px' }}>
                                                        <a
                                                          onClick={() => { return this.handleVexBom(item.uid); }}
                                                          onKeyUp={() => { return this.handleVexBom(item.uid); }}
                                                        >
                                                          <Icon name="download" style={iconStyle} />
                                                          VEX
                                                        </a>
                                                      </li>
                                                      <li style={{ padding: '0 0 0 20px' }}>
                                                        <a
                                                          onClick={() => { return this.handleNIASbom(item.uid); }}
                                                          onKeyUp={() => { return this.handleNIASbom(item.uid); }}
                                                        >
                                                          <Icon name="download" style={iconStyle} />
                                                          NIS
                                                        </a>
                                                      </li>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <li style={{ padding: '0 0 0 20px' }}>
                                                        <a
                                                          style={{
                                                            cursor: 'default',
                                                            opacity: '.45',
                                                            color: '#dddddd',
                                                          }}
                                                        >
                                                          <Icon name="download" style={iconStyle} />
                                                          {t('card.menu.spdx')}
                                                        </a>
                                                      </li>
                                                      <li style={{ padding: '0 0 0 20px' }}>
                                                        <a
                                                          style={{
                                                            cursor: 'default',
                                                            opacity: '.45',
                                                            color: '#dddddd',
                                                          }}
                                                        >
                                                          <Icon name="download" style={iconStyle} />
                                                          CycloneDX
                                                        </a>
                                                      </li>
                                                      <li style={{ padding: '0 0 0 20px' }}>
                                                        <a
                                                          style={{
                                                            cursor: 'default',
                                                            opacity: '.45',
                                                            color: '#dddddd',
                                                          }}
                                                        >
                                                          <Icon name="download" style={iconStyle} />
                                                          VEX
                                                        </a>
                                                      </li>
                                                      <li style={{ padding: '0 0 0 20px' }}>
                                                        <a
                                                          style={{
                                                            cursor: 'default',
                                                            opacity: '.45',
                                                            color: '#dddddd',
                                                          }}
                                                        >
                                                          <Icon name="download" style={iconStyle} />
                                                          NIS
                                                        </a>
                                                      </li>
                                                    </>
                                                  )}
                                                </ul>

                                              </li>
                                              {
                                                (item.scanStatus === 2 || item.scanStatus === 3)
                                                && (
                                                  <li>
                                                    {
                                                      item.scanStatus === 3
                                                    && (
                                                      <a
                                                        onClick={() => { return this.rescanReport(item.uid); }}
                                                        onKeyUp={() => { return this.rescanReport(item.uid); }}
                                                      >
                                                        <Icon name="refresh" style={iconStyle} />
                                                        {t('modal.new_scan.title.rescan')}
                                                      </a>
                                                    )
                                                    }
                                                    {
                                                      item.scanStatus === 2
                                                    && (
                                                      <a
                                                        onClick={() => { return this.refreshSecurityReport(item.uid); }}
                                                        onKeyUp={() => { return this.refreshSecurityReport(item.uid); }}
                                                      >
                                                        <Icon name="refresh" style={iconStyle} />
                                                        {t('modal.new_scan.title.refresh_security')}
                                                      </a>
                                                    )
                                                    }
                                                  </li>
                                                )
                                              }
                                              {
                                                (item.scanStatus === 2 && !item.isScanning)
                                                && (
                                                  <li>
                                                    <a
                                                      onClick={() => { return this.handleAddScanResults(item.uid); }}
                                                      onKeyUp={() => { return this.handleAddScanResults(item.uid); }}
                                                    >
                                                      <Icon name="add" style={iconStyle} />
                                                      {t('card.menu.add_scan_result')}
                                                    </a>
                                                  </li>
                                                )
                                              }
                                              <li>
                                                {item.hasPermission ? (
                                                  <a
                                                    onClick={() => { return this.handleDeleteOnList(item); }}
                                                    onKeyUp={() => { return this.handleDeleteOnList(item); }}
                                                  >
                                                    <img src={deleteIcon} alt="" />
                                                    {t('card.menu.delete')}
                                                  </a>
                                                ) : (
                                                  <a
                                                    style={{
                                                      cursor: 'default',
                                                      opacity: '.45',
                                                      color: '#dddddd',
                                                    }}
                                                  >
                                                    <img src={deleteIcon} alt="" />
                                                    {t('card.menu.delete')}
                                                  </a>
                                                )}
                                              </li>
                                            </ul>
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  }
                                </tbody>
                              </table>
                            </div>
                          );
                        })}
                        {
                          uploadedFiles.length !== 0
                        && (
                          <div style={{ marginTop: '10px', textAlign: 'center' }} className="clar_pagination">
                            <Pagination
                              activePage={currentPage}
                              totalPages={totalPage}
                              onPageChange={this.handlePaginationChange}
                              //size="mini"
                              ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                              firstItem={currentPage !== 1 ? { content: <Icon name="angle double left" />, icon: true } : null}
                              lastItem={currentPage !== totalPage ? { content: <Icon name="angle double right" />, icon: true } : null}
                              prevItem={currentPage > 1 ? { content: <Icon name="angle left" />, icon: true } : null}
                              nextItem={currentPage < totalPage ? { content: <Icon name="angle right" />, icon: true } : null}
                            />
                            <div className="active_page">
                              <Input
                                type="number"
                                label={t('list.title.active_page')}
                                min={1}
                                value={activePage}
                                onChange={this.handleInputActivePageChange}
                                onKeyPress={this.handleActivePageChange}
                              />
                            </div>
                          </div>
                        )
                        }
                        <Footer />
                      </div>
                    </div>
                  )
                }
              </div>
            )
          }
          <CompareModal
            isOpenCPM={isOpenCPM}
            isCompareLoading={isCompareLoading}
            closeModal={this.handleCPMClose}
            compareResult={compareResult}
            translate={t}
          />
          <ScanInfoModal
            isOpenMSI={isOpenMSI}
            reportId={scanInfoUid}
            closeModal={this.handleMSIClose}
            translate={t}
          />
          <LeakageListModal
            isOpenMLK={isOpenMLK}
            uploadedFileId={selectedUid}
            fileName={selectedName}
            closeModal={this.handleMLKClose}
            translate={t}
          />
          <ExportModal
            isOpenMED={modalExportIsOpen}
            onClose={this.closeExportModal}
            handleModal={this.downloadReport}
            isDownloading={isDownloadingReport}
            birdView
            rowData={currentData}
            translate={t}
          />
          <MoveFileModal
            isOpenMFM={isOpenMFM}
            closeModal={this.closeMoveFileModal}
            rowData={currentData}
            isMovingFile={isMovingFile}
            setFileMove={this.setFileMove}
            translate={t}
          />
          <SecurityRiskUpdatedModal
            isOpenMSU={isOpenMSU}
            reportId={currentUid}
            closeModal={this.closeModal}
            translate={t}
          />
          <DeleteModal
            isOpen={isOpenAlert}
            isSelectable={isSelectable}
            checkValues={checkValues}
            rowData={currentData}
            closeModal={this.closeModal}
            deletedCallback={this.deletedCallback}
            handleMultipleDeleteCallback={this.handleMultipleDeleteCallback}
            translate={t}
          />
          <SPDXDocumentGenerator
            isOpenMCX={isOpenMCX}
            reportId={reportId}
            uploadedFileName={uploadedFileName}
            closeModal={this.closeModal}
            translate={t}
          />
          <CycloneDXDocumentGenerator
            isOpenMCD={isOpenMCD}
            reportId={reportId}
            closeModal={this.closeModal}
            translate={t}
          />
          <VexGenerator
            isOpenMVX={isOpenMVX}
            reportId={reportId}
            closeModal={this.closeModal}
            translate={t}
          />
          <CBOMGenerator
            isOpenMCB={isOpenMCB}
            reportId={reportId}
            fileName={uploadedFileName}
            closeModal={this.closeModal}
            translate={t}
          />
          <NISModal
            isOpenMNA={isOpenMNA}
            reportId={reportId}
            translate={t}
            closeModal={this.closeModal}
          />
          <WarningModal
            isOpenWarnModal={isOpenWarnModal}
            closeModal={this.closeModal}
            translate={t}
          />
          <ScanResultModal
            isOpenMSR={isOpenMSR}
            reportId={reportId}
            translate={t}
            handleSaveCallback={this.handleSaveCallback}
            closeModal={this.closeModal}
          />
          <Modal open={isOpenAlertModal} onClose={this.closeModal}>
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.modalAction}</h2>
                  {
                    toExport === 's3' ? (
                      <Modal.Description>
                        <Header>
                          {this.modalBody}
                        </Header>
                        {this.modalHeader}
                        {this.modalSubBody}
                      </Modal.Description>
                    ) : (
                      <Modal.Description>
                        <Header>
                          {this.modalBody}
                        </Header>
                        <p className="modal_list">{this.modalHeader}</p>
                      </Modal.Description>
                    )
                  }

                  <div className="button_wrap">
                    <a className="center_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                      {t('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </DragDropContext>
      </div>
    );
  }
}
export default WithRouter(withTranslation()(inject('state')(observer(OverviewUploadedList))));
